import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import PageList from '../../components/PageListAPI'
import { getProjectJournal, delProjectJournal } from '../../api/journals'
import { useCan } from 'src/hooks/useCan'
import { SLUGS } from 'src/enum/permissions.enum'

export default function JournalCablesList() {
  const location = useLocation()
  const history = useHistory()
  const params = useParams()
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      title='Кабельные журналы'
      name='journal_cables-list'
      columns={[
        { id: 'journalNumber', name: 'Номер', width: 50 },
        { id: 'createdAt', name: 'Дата создания', type: 'date', formatDate: 'LLL' },
        { id: 'systemCode', name: 'Система', width: 50 },
        { id: 'title', name: 'Наименование' },
        { id: 'gostRef', name: 'ГОСТ' },
        { id: 'isActual', name: 'Актуальный', type: 'component', component: ({ obj }) => <div>{obj.isActual ? 'Да' : 'Нет'}</div> },
        { id: 'stage', name: 'Стадия' },
        { id: 'createdBy', name: 'Создан' },
      ]}
      createItem={can(SLUGS.PROJECT.JOURNAL.CREATE)}
      deleteItem={can(SLUGS.PROJECT.JOURNAL.DELETE)}
      loadAPI={{
        param: {
          id: params.idProject
        },
        request: getProjectJournal,
      }}
      deleteAPI={delProjectJournal(params.idProject)}
      headerInit={{
        sortBy: 'createdAt',
        sortDirection: 'desc',
      }}
      location={location}
      history={history}
    />
  </div>
}